(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Get a reference to the header element
const header = document.getElementById('shopify-section-header');

// Add a scroll event listener to the window
window.addEventListener('scroll', () => {
  // Define a scroll threshold where you want the class to be added
  const scrollThreshold = 100; // Adjust this value as needed

  // Check if the user has scrolled beyond the threshold
  if (window.scrollY > scrollThreshold) {
    // Add the desired class to the header
    header.classList.add('scrolled');
  } else {
    // Remove the class if the user scrolls back above the threshold
    header.classList.remove('scrolled');
  }
});


  } catch(e) { console.error(e); }
})();
})();
